let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("arhgZ"), load("7jk9K")]).then(() => parcelRequire('1Tm7l'));